/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_profile_tooltip_quali_vs_race = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gap shows positions gained/lost from qualifying to race`)
};

const es_f1_profile_tooltip_quali_vs_race = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La diferencia muestra posiciones ganadas/perdidas de clasificación a carrera`)
};

const de_f1_profile_tooltip_quali_vs_race = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Differenz zeigt gewonnene/verlorene Positionen vom Qualifying zum Rennen`)
};

const nl_f1_profile_tooltip_quali_vs_race = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verschil toont gewonnen/verloren posities van kwalificatie naar race`)
};

const fr_f1_profile_tooltip_quali_vs_race = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L’écart montre les positions gagnées/perdues entre qualification et course`)
};

const it_f1_profile_tooltip_quali_vs_race = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il divario mostra le posizioni guadagnate/perse tra qualifiche e gara`)
};

const pt_br2_f1_profile_tooltip_quali_vs_race = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diferença mostra posições ganhas/perdidas da classificatória para a corrida`)
};

const pt_f1_profile_tooltip_quali_vs_race = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A diferença mostra posições ganhas/perdidas da qualificação para a corrida`)
};

const ja_f1_profile_tooltip_quali_vs_race = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`予選からレースへのポジション変動を表示`)
};

const zh_f1_profile_tooltip_quali_vs_race = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`差值显示从排位赛到正赛获得/失去的位置`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_profile_tooltip_quali_vs_race = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_profile_tooltip_quali_vs_race(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_profile_tooltip_quali_vs_race", locale)
	if (locale === "en") return en_f1_profile_tooltip_quali_vs_race(inputs)
	if (locale === "es") return es_f1_profile_tooltip_quali_vs_race(inputs)
	if (locale === "de") return de_f1_profile_tooltip_quali_vs_race(inputs)
	if (locale === "nl") return nl_f1_profile_tooltip_quali_vs_race(inputs)
	if (locale === "fr") return fr_f1_profile_tooltip_quali_vs_race(inputs)
	if (locale === "it") return it_f1_profile_tooltip_quali_vs_race(inputs)
	if (locale === "pt-BR") return pt_br2_f1_profile_tooltip_quali_vs_race(inputs)
	if (locale === "pt") return pt_f1_profile_tooltip_quali_vs_race(inputs)
	if (locale === "ja") return ja_f1_profile_tooltip_quali_vs_race(inputs)
	return zh_f1_profile_tooltip_quali_vs_race(inputs)
};